<template>
  <v-divider class="my-2"></v-divider>
  <v-row class="align-start">
    <v-col cols="12">
      <v-expansion-panels>
        <v-expansion-panel
          :ripple="false"
          elevation="0"
          :hide-actions="!isLongDescription"
          :static="!isLongDescription"
        >
          <v-expansion-panel-title v-slot="{ expanded }">
            <v-row no-gutters>
              <v-col
                class="d-flex justify-start"
                :cols="showUnitMeasure ? 8 : 12"
              >
                <v-fade-transition leave-absolute>
                  <v-list
                    v-if="expanded"
                    class="py-0"
                    density="compact"
                    bg-color="transparent"
                  >
                    <v-list-item class="py-0">
                      <template v-slot:prepend>
                        <v-avatar color="primary" size="small">
                          <v-icon
                            color="white"
                            icon="mdi-text"
                            size="small"
                          ></v-icon>
                        </v-avatar>
                      </template>
                      <v-list-item-title>
                        {{ $t("labels.description") }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="!isLongDescription">
                        {{ description }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                  <v-list
                    v-else
                    class="py-0"
                    density="compact"
                    bg-color="transparent"
                  >
                    <v-list-item class="py-0">
                      <template v-slot:prepend>
                        <v-avatar color="primary" size="small">
                          <v-icon
                            color="white"
                            icon="mdi-text"
                            size="small"
                          ></v-icon>
                        </v-avatar>
                      </template>
                      <v-list-item-title>
                        {{ $t("labels.description") }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ description }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-fade-transition>
              </v-col>
              <v-col v-if="showUnitMeasure" cols="4">
                <v-fade-transition leave-absolute>
                  <v-row no-gutters>
                    <v-col class="d-flex justify-start" cols="12">
                      <v-list
                        class="py-0"
                        density="compact"
                        bg-color="transparent"
                      >
                        <v-list-item class="py-0">
                          <template v-slot:prepend>
                            <v-avatar color="primary" size="small">
                              <v-icon
                                color="white"
                                icon="mdi-ruler"
                                size="small"
                              ></v-icon>
                            </v-avatar>
                          </template>
                          <v-list-item-title>
                            {{ $t("labels.unit-measure") }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ unitMeasure || "Not set" }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </v-col>
            </v-row>
          </v-expansion-panel-title>
          <v-expansion-panel-text v-if="isLongDescription">
            <v-row>
              <v-col cols="12">
                <p>
                  {{ description }}
                </p>
              </v-col>
            </v-row>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
  <v-divider class="my-2"></v-divider>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      required: true,
    },
    unitMeasure: {
      type: String,
      required: false,
      default: '',
    },
    showUnitMeasure: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    isLongDescription() {
      return this.description.length > 45;
    },
  },
};
</script>
